export enum FeatureFlagNames {
    checkin_v4 = 'checkin_v4',
    invoicing_settlement = 'invoicing_settlement',
    unpaid_bills = "unpaid_bills",
    use_new_invoice_template = "use_new_invoice_template",
    use_new_invoice_template_for_etomotors = "use_new_invoice_template_for_etomotors",

    // app
    show_games_in_profile = 'show_games_in_profile',
    show_games_in_charging_process = 'show_games_in_charging_process',
    my_rfids = 'my_rfids',
    apply_for_rfid = 'apply_for_rfid',
    fastag_wallet = 'fastag_wallet',
    paytm_wallet = 'paytm_wallet',
    pulse_wallet = 'pulse_wallet',
    /**
     * Controls SUPEREV coupons & discounts (profile My Offers, charging offers
     * sheet, apply coupon on pay). Payment-partner offers also require this
     * plus `payment_partner_offers`.
     * @platform SUPEREV / InstaCharge variants
     */
    discounts = 'discounts',
    discounts_for_reservations = 'discounts_for_reservations',
    vrn_capturing = 'vrn_capturing',
    soc_capturing = 'soc_capturing',
    odo_capturing = 'odo_capturing',

    vrn_ocr = 'vrn_ocr',
    soc_ocr = 'soc_ocr',
    odo_ocr = 'odo_ocr',

    show_in_app_review = 'show_in_app_review',
    
    /**
     * @deprecated not applicable since we are relying on chargeTxn.bill.show_invoice_download_btn and chargeTxn.bill.show_receipt_download_btn to show invoice and receipt download buttons.
     */
    invoice_receipt_download_btns = 'invoice_receipt_download_btns',
    /**
     * Not used after v2.0.2
     */
    submit_cash_payment_via_link = 'submit_cash_payment_via_link',
    submit_cash_payment_via_sdk = 'submit_cash_payment_via_sdk',

    /**
     * @deprecated
     */
    pending_bills = 'pending_bills',
    use_new_issue_link = 'use_new_issue_link',
    fetch_payment_gateway_config = 'fetch_payment_gateway_config',
    iod = "iod",
    book_charger = 'book_charger',
    wallet_inflow_settlement = "wallet_inflow_settlement",
    use_new_entity_count_api = "use_new_entity_count_api",
    use_platform_fee_invoice = "use_platform_fee_invoice",

    new_cs_detail_screen = "new_cs_detail_screen",
    new_v3_endpoints = "new_v3_endpoints",
    use_new_find_route_logic = "use_new_find_route_logic",
    use_route_planner_v2 = "use_route_planner_v2",
    use_charge_based_routing = "use_charge_based_routing",
    use_soc_based_routing = "use_soc_based_routing",
    vehicle_selection = "vehicle_selection",

    /**
     * Determines if the Force logout feature should be enabled for a user or not
     *
     * @todo To be removed once users of all apps are migrated to higher version than v2.0.4
     */

    force_logout_on_backend = "force_logout_on_backend",
    /**
     * Determines if we should mail regarding issue ticket assignment to assignee or not
     */
    should_send_mail_to_issue_ticket_assignee = "should_send_mail_to_issue_ticket_assignee",

    energy_graph = "energy_graph",
    live_demand_graph = 'live_demand_graph',

    otm = "otm",

    /**
     * Determines if the Flat fee tariff should be shown for the fleet or not
     */
    tariff_wallet_fraud_prevention = "tariff_wallet_fraud_prevention",

    cs_ocpi_setup='cs_ocpi_setup',

    /**
     * Can be used to disable supervisor approval requests for everest
     */
    disable_supervisor_pending_check_ins = 'disable_supervisor_pending_check_ins',

    /**
     * Can be used to enable the fast charging session limit
     */
    fast_charging_session_limit_enabled = 'fast_charging_session_limit_enabled',

    /**
     * Can be used to enable OCR for everest
     */
    everest_check_in_ocr = 'everest_check_in_ocr',

    /**
     * Can be used to disable editing of odo and soc for everest drivers
     */
    should_disable_odo_and_soc_edit = 'should_disable_odo_and_soc_edit',

    /**
     * Can be used to enable TypeSense for charging stations
     */
    use_typesense_for_get_cs_by_id = 'use_typesense_for_get_cs_by_id',

    /**
     * Can be used to enable business agreement
     */
    business_agreement = 'business_agreement',

    /**
     * Can be used to enable TypeSense for charging stations
     */
    use_typesense_for_get_cs = 'use_typesense_for_get_cs',

    /**
     * Can be used to hide the Pulse energy logo in the invoice receipt
     */
    hide_powered_by_pulse_energy_branding = 'hide_powered_by_pulse_energy_branding',

    /**
     * Can be used to enable WhatsApp notifications when a charging transaction starts
     */
    whatsapp_notification_on_transaction_start = 'whatsapp_notification_on_transaction_start',

    /**
     * Energy market notifications
     */
    energy_market_notifications = 'energy_market_notifications',

    /**
     * Can be used to enable vehicle-level fast-to-slow charging limits
     * @deprecated Use fast_charging_session_limit_enabled instead
     */
    vehicle_level_fast_charging_limit = 'vehicle_level_fast_charging_limit',

    /**
     * Can be used to enable alerting
     */
    alerting = 'alerting',

    /**
     * Can be used to show the app variant column in the charge transaction report
     */
    show_app_variant_in_charge_transaction_report = 'show_app_variant_in_charge_transaction_report',

    /**
     * Can be used to enable the wallet switching feature.
     * 
     * @platform InstaCharge and variants
     * @note Only MG supports this in a particular version that was released before Dec 20. No Other apps support this
     * @deprecated Use can_switch_payment_method instead
     */
    is_wallet_enabled = 'is_wallet_enabled',

    /**
     * Can be used to enable the wallet switching feature
     * 
     * @platform InstaCharge and variants
     */
    can_switch_payment_method = 'can_switch_payment_method',

    /**
     * Push Notifications (legacy – used by older app versions / backend)
     * @platform InstaCharge and variants
     */
    push_notifications = 'push_notifications',

    /**
     * Push Notifications (v2 – used in newer app versions)
     * @platform InstaCharge and variants
     */
    push_notifications_v2 = 'push_notifications_v2',

    /**
     * Controls local contextual notifications for charging status updates
     * When enabled, displays foreground service notifications that poll API for charging status
     */
    local_contextual_notifications = 'local_contextual_notifications',

    /**
     * Controls whether street view is shown in charging station detail screen
     * When enabled, displays Google Street View panorama as header background
     */
    show_open_street_view = 'show_open_street_view',

    /**
     * Can be used to enable the fleet client feature
     */
    fleet_client = 'fleet_client',

    /**
     * Can be used to enable the fleet media approval feature
     */
    fleet_media_approval = 'fleet_media_approval',

    /**
     * Can be used to enable the fleet indicab trip feature
     */
    fleet_indicab_trip = 'fleet_indicab_trip',

    /**
     * Can be used to enable the fleet vehicle owner QR feature
     */
    fleet_vehicle_owner_qr = 'fleet_vehicle_owner_qr',

    /**
     * Can be used to enable the fleet vehicle owner immobilise feature
     */
    fleet_vehicle_owner_immobilise = 'fleet_vehicle_owner_immobilise',

    /**
     * Controls whether reset user wallet balance is allowed per user/org.
     * When enabled, allows console admins to reset retail user wallet balances.
     */
    reset_user_wallet_balance = 'reset_user_wallet_balance',

    /**
     * 
     * Controls whether reviews and ratings can be submitted after a charging session
     * When enabled, allows users to submit reviews and ratings after a charging session
     */
    can_submit_reviews_and_ratings = 'can_submit_reviews_and_ratings',


    /**
     * Controls whether custom discount codes can be used for charging
     * When enabled, allows users to use custom discount codes for charging
     */
    can_apply_custom_discount_codes = 'can_apply_custom_discount_codes',

    /**
     * Controls payment-partner / banking offers (BHIM, Amazon Pay, Paytm, etc.)
     * in the charging Offers & coupons sheet.
     * When disabled, the Payment offers section is hidden and the API is not called.
     * @platform SUPEREV / InstaCharge variants
     */
    payment_partner_offers = 'payment_partner_offers',

    /**
     * Controls whether the new QR scanning logic should be used for opening the charging pages
     * @platform InstaCharge and variants
     */
    new_qr_scanning_logic = 'new_qr_scanning_logic',

    /**
     * Controls visibility of UBC (Unified Beckn Connector) columns on existing pages
     * When enabled, shows UBC status indicators on charge points, charging stations, bills, and tariffs
     * @platform Console
     */
    ubc_columns = 'ubc_columns',

    /**
     * Decouples the fleet payment wallet from fleet context.
     * When enabled for a fleet, drivers can charge in fleet context while paying from the
     * wallet resolved via `fleet_payment_config` (personal PulseWallet vs fleet org wallet).
     * When disabled, fleet charging always uses the fleet operator wallet (legacy behavior).
     */
    fleet_personal_wallet = 'fleet_personal_wallet',

    /**
     * Hides plain personal wallets from wallet APIs for DCO pilots (e.g. Rapido/Everest).
     * When enabled, `/wallets/mine` omits `personal_wallets`; the DCO fleet wallet entry in
     * `fleet_wallets` (backed by the driver's PulseWallet) remains visible. Can be scoped by
     * app variant, user, org, or phone via the standard feature_flag row.
     */
    hide_personal_wallet = 'hide_personal_wallet',

    /**
     * Controls whether the fleet wallet balance can be reset from the console
     * When enabled, allows console admins to reset fleet wallet balances.
     */
    reset_fleet_wallet_balance = 'reset_fleet_wallet_balance',

    /**
     * Controls whether a webhook with the final transaction details is sent to Pulse Insights
     * every time a charge transaction is stopped. Can be enabled per org, charge point or
     * charging station.
     */
    charge_transaction_stopped_webhook = 'charge_transaction_stopped_webhook',

    /**
     * OCPP 1.6: stops an ongoing charging session when energy delivered has not increased for
     * `settings.stop_charging_on_no_energy_increase_config.threshold_minutes` of charge point / charging station / org (default 5) based on meter value timestamps.
     * Writes stop_reason NO_ENERGY_INCREASE_TIMEOUT in charge_transaction.additional_props.
     * Can be enabled per org, CPO org, charge point or charging station.
     */
    stop_charging_on_no_energy_increase = 'stop_charging_on_no_energy_increase',
}

export enum Client {
    Console = 'console',
}

export enum PlatformEnum {
    android = 'android',
    ios = 'ios',
}
